import React, {useEffect, useState} from 'react'
import {useAuth} from '../../../modules/auth'
import {addDoc, collection, doc, onSnapshot, serverTimestamp, updateDoc} from 'firebase/firestore'
import db from '../../../../services/firebase'
import Drawer from 'react-modern-drawer'
import {ToastContainer} from 'react-toastify'
import { showSuccessToast } from 'app/components/ShowToast'
import Button from 'app/components/Button'

interface AddProps {
  isOpen: boolean
  onClose: () => void
  id: string
}

const EditTask: React.FC<AddProps> = ({isOpen, onClose, id}) => {
  const {currentUser} = useAuth()
  const [dueDate, setDueDate] = useState('')
  const [taskName, setTaskName] = useState('')
  const [priority, setPriority] = useState('')
  const [controlTask, setControlTask] = useState('')
  const [testTask, setTestTask] = useState('')
  const [owners, setOwners] = useState<any[]>([])
  const [owner, setOwner] = useState('')
  const [selectedOwnerEmail, setSelectedOwnerEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [formErrors, setFormErrors] = useState<Record<string, string>>({})
  const [description, setDescription] = useState('')
  const [originalData, setOriginalData] = useState<any>(null)

  useEffect(() => {
    const tenantId = currentUser?.tenantId || ''
    if (!tenantId) {
      // Logout()
      return
    }
    const tenantRef = doc(db, 'tenants', tenantId)
    const PolicyRef = collection(tenantRef, 'employees')

    // const limitedQuery = query(controlsCollectionRef, limit(10))

    const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
      const risksData = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }))
      setOwners(risksData)
    })

    return unsubscribe
  }, [])
  const getTask = async () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const PolicyRef = collection(tenantRef, 'tasklists')
      const riskDocRef = doc(PolicyRef, id)

      const unsubscribe = onSnapshot(riskDocRef, (doc) => {
        if (doc.exists()) {
          const taskData = doc.data()

          setTaskName(taskData.task_name)
          setControlTask(taskData.control)
          setTestTask(taskData.test)
          setPriority(taskData.priority)
          setOwner(taskData.owner)
          setDueDate(taskData.duedate)
          setDescription(taskData.description)
          
          // Find the owner's email from the owners list
          const ownerData = owners.find((o) => o.full_name === taskData.owner);
          if (ownerData) {
            setSelectedOwnerEmail(ownerData.email);
          }
          
          // Store original data for comparison
          setOriginalData({
            task_name: taskData.task_name,
            description: taskData.description,
            priority: taskData.priority,
            owner: taskData.owner,
            duedate: taskData.duedate,
            control: taskData.control,
            test: taskData.test
          });
        }
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting risk:', error)
    }
  }

  useEffect(() => {
    if (id !== '' && id !== undefined) {
      getTask()
    }
  }, [id])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)

    if (!validateForm()) {
      setLoading(false)
      return
    }

    const selectedOwner = owners.find((o) => o.full_name === owner);
    const assigneeId = selectedOwner ? selectedOwner.uid : null;

    const currentDate = new Date()
    const year = currentDate.getFullYear()
    const month = currentDate.getMonth() + 1
    const day = currentDate.getDate()

    const todaysDate = `${month}/${day}/${year}`

    try {
      if (currentUser) {
        const tenantRef = doc(db, 'tenants', currentUser.tenantId!)
        const tasksRef = collection(tenantRef, 'tasklists')
        const taskDocRef = doc(tasksRef, id)

        await updateDoc(taskDocRef, {
          task_name: taskName.trim(),
          description: description,
          priority,
          owner,
          assignee_id: assigneeId,
          duedate: dueDate,
          control: controlTask,
          test: testTask,
          date: todaysDate,
        })

        const activitiesRef = collection(tenantRef, 'activities')
        await addDoc(activitiesRef, {
          message: `${currentUser?.userName} updated task "${taskName.trim()}"`,
          timestamp: serverTimestamp(),
          tenantId: currentUser?.tenantId,
          uid: currentUser?.uid,
          action: 'Asset updated',
          target: 'Asset Management',
          email: currentUser?.email,
          username: currentUser?.userName,
          date: todaysDate,
        })
        showSuccessToast({message: 'Task edited successfully!'})
        setTimeout(() => {
          onClose()
        }, 1000)
      }
    } catch (error) {
      showSuccessToast({message: 'Error editing task!'})
    }
    setLoading(false)
  }

  const validateForm = () => {
    const errors: Record<string, string> = {}

    if (!taskName.trim()) {
      errors.taskName = 'Task Name is required'
    }

    if (!priority.trim()) {
      errors.priority = 'Task priority is required'
    }

    // if (!owner.trim()) {
    //   errors.owner = 'Task Owner is required'
    // }

    if (!dueDate.trim()) {
      errors.dueDate = 'Task DueDate is required'
    }

    setFormErrors(errors)
    return Object.keys(errors).length === 0
  }

  const hasChanges = () => {
    if (!originalData) return false;
    
    return (
      taskName !== originalData.task_name ||
      description !== originalData.description ||
      priority !== originalData.priority ||
      owner !== originalData.owner ||
      dueDate !== originalData.duedate ||
      controlTask !== originalData.control ||
      testTask !== originalData.test
    );
  };

  return (
    <>
      <Drawer open={isOpen} onClose={onClose} direction='right' className='' size='45%'>
        <div
          className=' modal-dialog-centered border-bottom border-gray-300'
          style={{
            position: 'sticky',
            top: 0,
            backgroundColor: 'white',
            padding: '14px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            paddingLeft: '15px',
            paddingRight: '12px',
          }}
        >
          <div className='fs-4 fw-bold mx-2' style={{margin: 0}}>
            Edit Task
          </div>

          <div style={{display: 'flex', gap: '16px'}}>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary '
              onClick={onClose}
              aria-label='Close'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='20'
                viewBox='0 0 24 24'
                fill='none'
                stroke='#5A5A5A'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
                className='icon icon-tabler icons-tabler-outline icon-tabler-x'
              >
                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                <path d='M18 6l-12 12' />
                <path d='M6 6l12 12' />
              </svg>
            </div>
          </div>
        </div>
        <div
          className='p-6 scroll-y overflow-auto '
          tabIndex={-1}
          style={{height: 'calc(100vh - 20px)'}}
        >
          <div className='modal-body'>
            <form className='' onSubmit={handleSubmit}>
              <div className='fs-6 mb-4'>
                Delegate tasks which might help you fix your controls and tests to you team members.
                You can also add due dates to ensure audit readiness.{' '}
              </div>
              <div className='fv-row mb-4 '>
                <label className=' fw-semibold fs-6 mb-1 required'>Task Name</label>
                <input
                  placeholder='Enter Task Name'
                  type='text'
                  className={`form-control ${formErrors.taskName ? 'is-invalid' : ''}`}
                  name='taskname'
                  value={taskName}
                  onChange={(e) => {
                    setTaskName(e.target.value)
                    setFormErrors((prev) => ({...prev, taskName: ''}))
                  }}
                  autoComplete='off'
                />
                {formErrors.taskName && (
                  <div className='invalid-feedback'>{formErrors.taskName}</div>
                )}
              </div>

              <div className='fv-row mb-4'>
                  <label className='fw-bold fs-6 mb-2'>Description</label>
                  <textarea
                    placeholder='Enter description for task'
                    className='form-control mb-3 mb-lg-0 w-100'
                    name='description'
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    autoComplete='off'
                  />
                </div>

              {/* <div className='fv-row mb-4 '>
                <label className=' fw-semibold fs-6 mb-1'>Map to control</label>
                <select
                  className='form-select  mb-3 mb-lg-0 w-100'
                  value={controlTask}
                  onChange={(e) => setControlTask(e.target.value)}
                >
                  <option selected>Select control</option>
                  <option value='Determining the scope of the information security management system'>
                    Determining the scope of the information security management system
                  </option>
                  <option value='Inventory of information and other associated assets'>
                    Inventory of information and other associated assets
                  </option>
                  <option value='Intellectual property rights'>Intellectual property rights</option>
                  <option value='Security of assets off-premises'>
                    Security of assets off-premises
                  </option>
                  <option value='Storage media'>Storage media</option>
                  <option value='Secure disposal or re-use of equipment'>
                    Secure disposal or re-use of equipment
                  </option>
                </select>
              </div>

              <div className='fv-row mb-4 '>
                <label className=' fw-semibold fs-6 mb-1'>Map to test</label>
                <select
                  className='form-select  mb-3 mb-lg-0 w-100'
                  value={testTask}
                  onChange={(e) => setTestTask(e.target.value)}
                >
                  <option selected>Select Test</option>
                  <option value='A process exists to identify and prioritize security vulnerabilities'>
                    A process exists to identify and prioritize security vulnerabilities
                  </option>
                  <option value='Access request ticket and history'>
                    Access request ticket and history
                  </option>
                  <option value='Company has an approved Asset Management Policy'>
                    Company has an approved Asset Management Policy
                  </option>
                  <option value='Assets returned by employees'>Assets returned by employees</option>
                  <option value='Backups completed for other databases'>
                    Backups completed for other databases
                  </option>
                  <option value='Cloud provider service agreement'>
                    Cloud provider service agreement
                  </option>
                </select>
              </div> */}

              <div className='fv-row mb-4 '>
                <label className=' fw-semibold fs-6 mb-1 required'>Priority</label>
                <select
                  className={`form-select  ${formErrors.priority ? 'is-invalid' : ''}`}
                  value={priority}
                  onChange={(e) => {
                    setPriority(e.target.value)
                    setFormErrors((prev) => ({...prev, priority: ''}))
                  }}
                >
                  <option selected>Select Priority</option>
                  <option value='Low'>Low</option>
                  <option value='Medium'>Medium</option>
                  <option value='High'>High</option>
                </select>
                {formErrors.priority && <span className='text-danger'>{formErrors.priority}</span>}
              </div>
              <div className='fv-row  '>
                <label className=' fw-semibold fs-6 mb-1'>Assign to</label>
                <select
                  data-placeholder='Select Owner'
                  onChange={(e) => {
                    const [selectedFullName, selectedEmail] = e.target.value.split('|');
                    setOwner(selectedFullName);
                    setSelectedOwnerEmail(selectedEmail);
                    setFormErrors((prev) => ({...prev, owner: ''}))
                  }}
                  value={owner ? `${owner}|${selectedOwnerEmail}` : ''}
                  className={`form-select  ${formErrors.owner ? 'is-invalid' : ''}`}
                >
                  <option value='' selected>
                    Select Owner
                  </option>
                  {owners
                    .filter((user) => user.role === 'Admin' || user.role === 'Owner')
                    .map((owner) => (
                      <option key={owner.id} value={`${owner.full_name}|${owner.email}`}>
                        {owner.full_name}
                      </option>
                    ))}
                </select>
                {formErrors.owner && <span className='text-danger'>{formErrors.owner}</span>}
              </div>

              <div className='form-group'>
                <label className='fw-semibold text-dark mt-5 fs-6 mb-1 required'>Due date</label>
                <input
                  type='date'
                  className={`form-control   ${formErrors.dueDate ? 'is-invalid mb-20' : 'mb-5'}`}
                  placeholder='Selcted due date'
                  name='dateOfLastReview'
                  value={dueDate}
                  onChange={(e) => {
                    setDueDate(e.target.value)
                    setFormErrors((prev) => ({...prev, dueDate: ''}))
                  }}
                />
                {formErrors.dueDate && <span className='text-danger'>{formErrors.dueDate}</span>}
              </div>
            </form>
          </div>
        </div>
        <div
          className='offcanvas-footer d-flex justify-content-end  border-top mt-8 py-4'
          style={{position: 'sticky', bottom: 0, backgroundColor: 'white'}}
        >
          <div className='d-flex justify-content-end align-items-center mx-6 gap-3'>
            <Button
              btnType='secondary'
              onClick={onClose}
            >
              Cancel
            </Button>
            {loading ? (
              <Button
                btnType='primary'
                disabled
              >
                Saving... <span className='spinner-border spinner-border-sm align-middle'></span>
              </Button>
            ) : (
              <Button
              btnType='primary'
                onClick={handleSubmit}
                disabled={!hasChanges()}
              >
                Save
              </Button>
            )}
          </div>
        </div>
      </Drawer>
      <ToastContainer />
    </>
  )
}

export default EditTask
